module.exports = __webpack_public_path__ + "media/ap-modelx.26799ac7.mp4";